import styles from './SplashPage.module.css';
import { GameCard } from './GameCard';
import { ENABLED_GAMES } from '../constants';
import labGif from './cooknick-labs.gif'

export const SplashPage = () => {
  return (<div className={styles.splashWrapper}>
    <div className={styles.splashHeader}>
      <h1>Cooknick  <img alt="Cooknick Labs Logo" src={labGif} width={55} />  Labs</h1>
      {/* https://unicodeplus.com/U+10082 
      <span className={styles.purple}>𐂂</span>
      */}
    </div>
    <div>
      {ENABLED_GAMES.length > 0
        ? <div className={styles.gameList}>
          {ENABLED_GAMES?.map(game => <GameCard game={game} />)}
        </div>
        : <div className={styles.noGames}> No Games Available Yet</div>}
    </div>
  </div>)
}